import { createTheme, type ThemeOptions } from '@mui/material';
// @ts-ignore
import defaultTheme from '@mui/material/styles/defaultTheme';

const secondary = '#fff';
const primary = '#197CB3';
const primaryControlColor = '#1D428A';
const primaryControlHoverColor = '#142E61';
const primaryCardBackground = '#F6FAFC';
const success = '#2E7D32';
const info = '#6c6d6e';
const warning = '#E65100';
const error = '#C62828';
const headerBackground = '#1D428A';
const navTextColor = 'rgba(255, 255, 255, 0.75)';
const navTextHoverColor = '#FFF';
const navTextActiveColor = '#FFF';
const footerBackground = '#1D428A';
const footerTextColor = '#FFF';
const iconSecondaryColor = '#01101299';
const lightTextPrimary = 'rgba(1, 16, 18, 0.90)';
const lightTextSecondary = 'rgb(103, 112, 113)';
const lightTextDisabled = 'rgb(140, 147, 148)';
const lightErrorMain = 'rgb(211, 47, 47)';
const lightActionDisabled90p = 'rgba(1, 16, 18, 0.90)';
const lightActionDisabled60p = 'rgba(1, 16, 18, 0.60)';
const lightActionDisabled54p = 'rgba(1, 16, 18, 0.54)';
const lightActionDisabled45p = 'rgba(1, 16, 18, 0.45)';
const lightActionDisabled26p = 'rgba(1, 16, 18, 0.26)';
const lightActionDisabled15p = 'rgba(1, 16, 18, 0.15)';
const lightActionDisabled12p = 'rgba(1, 16, 18, 0.12)';
const lightActionDisabled04p = 'rgba(1, 16, 18, 0.04)';
const lightPrimaryShades04p =
  'linear-gradient(0deg, rgba(25, 124, 179, 0.04) 0%, rgba(25, 124, 179, 0.04) 100%)';
const lightGrayToTransparentGradient =
  'linear-gradient(90deg,rgba(241, 241, 241, 1) 50%, rgba(241, 241, 241, 0) 85%)';
const river = '#3D7494';
const slate = '#475057';
const white04p = 'rgba(255, 255, 255, 0.04)';
const whiteOverlay90p = 'rgba(255, 255, 255, 0.9)';
const lightSecondaryPrimarySubtle = 'rgb(83, 93, 94)';
const lightBackgroundPaperHover = 'rgb(245, 245, 246)';

const shadows = [...defaultTheme.shadows];
shadows[2] = '0px 2px 7px 0px rgba(1, 16, 18, 0.15)'; //Elevation2
shadows[3] = '0px 4px 8px 0px rgba(1, 16, 18, 0.15)'; //Elevation3
shadows[16] = `
  rgb(255, 255, 255) 0px 0px 0px 0px,
  rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
  rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
  rgba(0, 0, 0, 0.05) 0px 4px 6px -2px
`; //Elevation16

const palette: ThemeOptions['palette'] = {
  mode: 'light',
  primary: {
    main: primary,
  },
  secondary: {
    main: secondary,
  },
  info: {
    main: info,
  },
  success: {
    main: success,
  },
  warning: {
    main: warning,
  },
  error: {
    main: error,
    light: lightErrorMain,
  },
  buttonColor: {
    main: primaryControlColor,
  },
  buttonHoverColor: {
    main: primaryControlHoverColor,
  },
  headerBackground: {
    main: headerBackground,
  },
  navigationTextColor: {
    main: navTextColor,
  },
  navigationTextHoverColor: {
    main: navTextHoverColor,
  },
  navigationTextActiveColor: {
    main: navTextActiveColor,
  },
  footerBackground: {
    main: footerBackground,
  },
  footerTextColor: {
    main: footerTextColor,
  },
  iconSecondaryColor: {
    main: iconSecondaryColor,
  },
  lightTextPrimary: {
    main: lightTextPrimary,
  },
  lightTextSecondary: {
    main: lightTextSecondary,
  },
  lightTextDisabled: {
    main: lightTextDisabled,
  },
  lightActionDisabled90p: {
    main: lightActionDisabled90p,
  },
  lightActionDisabled60p: {
    main: lightActionDisabled60p,
  },
  lightActionDisabled54p: {
    main: lightActionDisabled54p,
  },
  lightActionDisabled45p: {
    main: lightActionDisabled45p,
  },
  lightActionDisabled26p: {
    main: lightActionDisabled26p,
  },
  lightActionDisabled15p: {
    main: lightActionDisabled15p,
  },
  lightActionDisabled12p: {
    main: lightActionDisabled12p,
  },
  lightActionDisabled04p: {
    main: lightActionDisabled04p,
  },
  lightPrimaryShades04p: {
    main: lightPrimaryShades04p,
  },
  lightGrayToTransparentGradient: {
    main: lightGrayToTransparentGradient,
  },
  river: {
    main: river,
  },
  slate: {
    main: slate,
  },
  white04p: {
    main: white04p,
  },
  primaryCardBackground: {
    main: primaryCardBackground,
  },
  whiteOverlay90p: {
    main: whiteOverlay90p,
  },
  lightSecondaryPrimarySubtle: {
    main: lightSecondaryPrimarySubtle,
  },
  lightBackgroundPaperHover: {
    main: lightBackgroundPaperHover,
  },
};

const paletteTheme = createTheme({
  palette,
  shadows,
} as ThemeOptions);

export { palette, paletteTheme };
